// extracted by mini-css-extract-plugin
export default {"toggle-switch-wrapper":"MQNXN0iN4eAyaQT8RTOBnw==","toggle-button":"Yzvas2rcnEzPJVW4NyVgEw=="};